// Format money using the currency stored in localStorage (synced from /api/settings).
export const getCurrency = () => localStorage.getItem("boba_currency") || "$";

export const setCurrency = (c) => {
  if (c) localStorage.setItem("boba_currency", c);
};

export const fmt = (n) => `${getCurrency()}${Number(n || 0).toFixed(2)}`;
